import classnames from 'classnames';
import React, { useContext } from 'react';
import { RicosAlignmentContext, VisibleIndentationContext, VisibleIndentationContextProvider, RicosNodeContextProvider } from 'ricos-context';
import { TextStyle_TextAlignment } from 'ricos-schema';
import { a as alignmentStyle } from '../../../../alignment.rtlignore-5b2a79a8.js';
import { s as styles } from '../../../../lists-791021fb.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BulletedList = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b;
  const { textAlignment } = useContext(RicosAlignmentContext);
  const { visibleIndentation } = useContext(VisibleIndentationContext);
  const currIndentation = (visibleIndentation == null ? void 0 : visibleIndentation.indentation) || 0;
  const currOffset = ((_a = node.bulletedListData) == null ? void 0 : _a.offset) || 0;
  const indentation = (visibleIndentation && (visibleIndentation == null ? void 0 : visibleIndentation.nodeId) !== node.id ? 1 : 0) + currIndentation + currOffset;
  const bulletedListClassName = classnames(
    styles.bulletedlist,
    alignmentStyle[textAlignment || TextStyle_TextAlignment.AUTO]
  );
  return /* @__PURE__ */ React.createElement("ul", { className: bulletedListClassName }, /* @__PURE__ */ React.createElement(VisibleIndentationContextProvider, { visibleIndentation: { indentation, nodeId: node.id } }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: (_b = node.nodes) != null ? _b : [] }))));
};
const BulletedListRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(BulletedList, __spreadValues({ key: node.id, node }, props));
};

export { BulletedListRenderer as default };
//# sourceMappingURL=bulletedList.js.map
